export default "__VITE_ASSET__a9815046__"